(function () {
  function init() {
    var mapEl = document.querySelector('[id^="VariantMediaMap-"]');
    if (!mapEl) return;

    var mediaMap;
    try { mediaMap = JSON.parse(mapEl.textContent); } catch (e) { return; }
    if (!mediaMap || !Object.keys(mediaMap).length) return;

    var sid = mapEl.id.replace('VariantMediaMap-', '');
    var form = document.getElementById('product-form-' + sid);
    if (!form) return;
    var input = form.querySelector('input[name="id"]');
    if (!input) return;

    var dm = Array.from(document.querySelectorAll('.product__media-desktop [data-group-thumb]'));
    var dt = Array.from(document.querySelectorAll('.product__media-desktop [data-group]'));
    var mm = Array.from(document.querySelectorAll('.product__media-mobile [data-group-thumb]'));
    var mt = Array.from(document.querySelectorAll('.product__media-mobile [data-group]'));
    var gi = Array.from(document.querySelectorAll('.product__media-desktop .gallery-img[data-media-id]'))
      .filter(function (el) { return !el.closest('.swiper-wrapper'); });

    var dmW = document.querySelector('.product__media-desktop [data-thumb-feature]');
    var dtW = document.querySelector('.product__media-desktop [data-nav-thumb]');
    var mmW = document.querySelector('.product__media-mobile [data-thumb-feature]');
    var mtW = document.querySelector('.product__media-mobile [data-nav-thumb]');

    function getMid(el) {
      return String(el.dataset.mediaId || (el.querySelector('[data-media-id]') || {}).dataset.mediaId || '');
    }

    function filterSwiper(slides, wrapper, ids) {
      if (!slides.length || !wrapper) return;
      var sw = wrapper.parentElement && wrapper.parentElement.swiper;
      if (!sw) return;
      var slideMap = {};
      slides.forEach(function (el) { slideMap[getMid(el)] = el; });
      var ordered = ids.map(function (id) { return slideMap[String(id)]; }).filter(Boolean);
      if (!ordered.length) return;
      sw.removeAllSlides();
      sw.appendSlide(ordered);
      ordered.forEach(function (el, i) {
        el.setAttribute('data-position', i + 1);
        el.classList.add('media-active');
        el.classList.remove('media-hidden');
        var inner = el.querySelector('.gallery-img');
        if (inner) inner.setAttribute('data-position', i + 1);
      });
      sw.slideTo(0, 0, false);
      sw.update();
      setTimeout(function () { if (sw) sw.update(); }, 50);
    }

    function applyFilter(variantId) {
      var ids = mediaMap[String(variantId)];
      if (!ids || !ids.length) return;
      var strIds = ids.map(String);
      var allowed = new Set(strIds);
      filterSwiper(dm, dmW, strIds);
      filterSwiper(dt, dtW, strIds);
      filterSwiper(mm, mmW, strIds);
      filterSwiper(mt, mtW, strIds);
      gi.forEach(function (el) {
        var mid = String(el.dataset.mediaId || '');
        if (allowed.has(mid)) {
          el.classList.remove('media-hidden');
          el.classList.add('media-active');
        } else {
          el.classList.add('media-hidden');
          el.classList.remove('media-active');
        }
      });
    }

    function tryInit(attempts) {
      var hasSwiper = !dmW || (dmW.parentElement && dmW.parentElement.swiper);
      if (!hasSwiper && attempts < 20) {
        requestAnimationFrame(function () { tryInit(attempts + 1); });
        return;
      }
      applyFilter(input.value);
    }
    tryInit(0);

    form.addEventListener('change', function (e) {
      if (e.target.name === 'id') {
        var vid = e.target.value;
        requestAnimationFrame(function () { applyFilter(vid); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();